<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title>Журнал истории активности</v-card-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer mt-1 mb-2"
            v-bind="attrs"
            v-on="on"
            @click="updateInfo"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-data-table
      class="table"
      :headers="actionsJournal"
      :items="actions"
      :options.sync="options"
      :server-items-length="totalJournal"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, 100],
        showFirstLastPage: true
      }"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ ruDateFormat(item.created_at) }}
      </template>
      <template v-slot:item.abonent\.telephone="{ item }">
        <div v-if="item.abonent">
          <router-link class="routerLink" :to="`/resident-accounts/${item.abonent_id}`">
            {{item.abonent.telephone}}
          </router-link>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { actionsJournal } from '../consts';
import watchTableOptions from '@/mixins/watchTableOptions';
import { DEFAULT_DATA_TABLE_OPTIONS } from '@/constants/data-table';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'actions',
  mixins: [watchTableOptions, ruDateFormatMixin],
  props: ['id'],
  data () {
    return {
      isCreated: false,
      options: DEFAULT_DATA_TABLE_OPTIONS,
      totalJournal: 0,
      actionsJournal,
    };
  },
  created () {
    this.isCreated = true;
    this.loadActions();
  },
  computed: {
    ...mapGetters({
      actions: 'Doorphone/actions',
    }),
  },
  methods: {
    ...mapActions({
      getActions: 'Doorphone/getActions',
    }),
    updateInfo () {
      this.loadActions();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadActions () {
      this.getActions({
        id: this.$route.params.id,
        options: {
          page: this.options.page,
          limit: this.options.itemsPerPage,
        },
      })
        .then((response) => {
          this.totalJournal = response.meta.total;
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Не удалось получить журнал истории активности');
        });
    },
  },
  watch: {
    options (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.loadActions();
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
